import React from "react";
import styled from "styled-components";

/**
 * Cinesys wordmark — white lockup, sourced from Drive (`CineSys.io_2026_Logo_White.svg`) and
 * copied byte-for-byte into this app's own `public/assets/imgs/` (same pattern as `AbLogo.tsx`'s
 * `ab_logo_wht.png`, including the `PUBLIC_URL` resolution — see that file's doc comment). Shared
 * by every customer-interface header's "Powered by" badge (`SpotterHeader.tsx`, `AbHeader.tsx`) — not
 * an org's own iconik logo, which is never shown in any of these headers.
 */
const Img = styled.img<{ $height: number }>`
  height: ${(p) => p.$height}px;
  width: auto;
  display: block;
`;

const LOGO_SRC = `${
  process.env.PUBLIC_URL ?? ""
}/assets/imgs/cinesys_logo_white.svg`;

/** Where every "Powered by" Cinesys badge links out to. */
export const CINESYS_URL = "https://cinesys.io";

const CinesysLogo = ({ height = 26 }: { height?: number }) => (
  <Img src={LOGO_SRC} alt="Cinesys" $height={height} />
);

export default CinesysLogo;
